import { PFixHistoryResponseMessage } from '../Messages/PFixHistoryResponseMessage';
import { MessageProcessorBase } from './MessageProcessorBase';
export class PFixHistoryMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new PFixHistoryResponseMessage(fieldSet);
        return [message];
    }
}
